import { classInstance } from '@/shared/helpers/helpers';

export class ProductShare {
	private readonly element: HTMLElement | null;
	private readonly duration = 3000;

	constructor(element: HTMLElement | null) {
		this.element = element;
		this.init();
	}

	private handleClick = async () => {
		const { origin, pathname } = window.location;
		const string: string = `${origin}${pathname}`;
		const clipboardItem = new ClipboardItem({ 'text/plain': string });
		await navigator.clipboard.write([clipboardItem]);
		window.app.notify.append({
			id: 'notify-product-share',
			delay: this.duration,
			content: 'Ссылка на товар уже скопирована',
		});
	};

	private bindEvents = (): void => {
		this.element.addEventListener('click', this.handleClick);
	};

	private unbindEvents = (): void => {
		this.element.removeEventListener('click', this.handleClick);
	};

	public init = (): void => {
		if (!this.element) return;

		classInstance.set(this.element, { productInfoCode: this });

		this.bindEvents();
	};

	public destroy = (): void => {
		if (!this.element) return;

		this.unbindEvents();
		classInstance.del(this.element, 'productInfoCode');
	};

	public reinit = (): void => {
		this.destroy();
		this.init();
	};
}
